import React, { useMemo } from 'react';
import { Row, Col, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, ButtonGroup, UncontrolledDropdown } from 'reactstrap';
import TableContainerReactTable from 'Components/Common/TableContainerReactTable';

const PricesTab: React.FC = () => {
  const columns = useMemo(() => [
    { header: 'Product Id', accessorKey: 'productId', enableColumnFilter: false, cell: (cell: any) => (<div>{cell.getValue()}</div>) },
    { header: 'Size', accessorKey: 'size', enableColumnFilter: false, cell: (cell: any) => (<div>{cell.getValue()}</div>) },
    { header: 'Colour', accessorKey: 'colour', enableColumnFilter: false, cell: (cell: any) => (<div>{cell.getValue()}</div>) },
    { header: 'Product Code', accessorKey: 'productCode', enableColumnFilter: false, cell: (cell: any) => (<div>{cell.getValue()}</div>) },
    { header: 'Name', accessorKey: 'productName', enableColumnFilter: false, cell: (cell: any) => (<div>{cell.getValue()}</div>) },
    { header: 'Cost', accessorKey: 'cost', enableColumnFilter: false, cell: (cell: any) => (<div>{Number(cell.getValue()).toFixed(2)}</div>) },
    { header: 'Pur Exc', accessorKey: 'purchaseExcl', enableColumnFilter: false, cell: (cell: any) => (<div>{Number(cell.getValue()).toFixed(2)}</div>) },
    { header: 'Pur Inc', accessorKey: 'purchaseIncl', enableColumnFilter: false, cell: (cell: any) => (<div>{Number(cell.getValue()).toFixed(2)}</div>) },
    { header: 'Pur Cur', accessorKey: 'purchaseCurrency', enableColumnFilter: false, cell: (cell: any) => (<div>{cell.getValue()}</div>) },
    { header: 'Pur Tax', accessorKey: 'purchaseTax', enableColumnFilter: false, cell: (cell: any) => (<div>{Number(cell.getValue()).toFixed(2)}</div>) },
    { header: 'Sell price', accessorKey: 'sellPrice', enableColumnFilter: false, cell: (cell: any) => (<div>{Number(cell.getValue()).toFixed(2)}</div>) },
    { header: 'Sell Price Inc', accessorKey: 'sellPriceIncl', enableColumnFilter: false, cell: (cell: any) => (<div>{Number(cell.getValue()).toFixed(2)}</div>) },
    { header: 'Sales Tax', accessorKey: 'salesTax', enableColumnFilter: false, cell: (cell: any) => (<div>{Number(cell.getValue()).toFixed(2)}</div>) },
    { header: 'Markup %', accessorKey: 'markupPct', enableColumnFilter: false, cell: (cell: any) => (<div>{Number(cell.getValue()).toFixed(2)}</div>) },
  ], []);

  const data = useMemo(() => [
    { productId: '1001', size: '12', colour: 'Blue', productCode: 'P-1001', productName: 'Sample Product A', cost: 8.5, purchaseExcl: 9.5, purchaseIncl: 11.4, purchaseCurrency: 'USD', purchaseTax: 1.9, sellPrice: 14.0, sellPriceIncl: 16.1, salesTax: 2.1, markupPct: 47.37 },
    { productId: '1002', size: '14', colour: 'Red', productCode: 'P-1002', productName: 'Sample Product B', cost: 6.2, purchaseExcl: 7.2, purchaseIncl: 8.6, purchaseCurrency: 'USD', purchaseTax: 1.4, sellPrice: 12.0, sellPriceIncl: 13.8, salesTax: 1.8, markupPct: 66.67 },
    { productId: '1003', size: '16', colour: 'Yellow', productCode: 'P-1003', productName: 'Sample Product C', cost: 5.0, purchaseExcl: 6.0, purchaseIncl: 7.2, purchaseCurrency: 'USD', purchaseTax: 1.2, sellPrice: 10.0, sellPriceIncl: 11.5, salesTax: 1.5, markupPct: 66.67 },
    { productId: '1004', size: '12', colour: 'Blue', productCode: 'P-1004', productName: 'Sample Product D', cost: 9.1, purchaseExcl: 10.0, purchaseIncl: 12.0, purchaseCurrency: 'USD', purchaseTax: 2.0, sellPrice: 15.0, sellPriceIncl: 17.3, salesTax: 2.3, markupPct: 50.00 },
    { productId: '1005', size: '14', colour: 'Red', productCode: 'P-1005', productName: 'Sample Product E', cost: 7.3, purchaseExcl: 8.1, purchaseIncl: 9.7, purchaseCurrency: 'USD', purchaseTax: 1.6, sellPrice: 13.2, sellPriceIncl: 15.2, salesTax: 2.0, markupPct: 62.96 },
    { productId: '1006', size: '16', colour: 'Yellow', productCode: 'P-1006', productName: 'Sample Product F', cost: 4.9, purchaseExcl: 5.5, purchaseIncl: 6.6, purchaseCurrency: 'USD', purchaseTax: 1.1, sellPrice: 9.9, sellPriceIncl: 11.4, salesTax: 1.5, markupPct: 80.61 },
    { productId: '1007', size: '12', colour: 'Blue', productCode: 'P-1007', productName: 'Sample Product G', cost: 10.0, purchaseExcl: 11.0, purchaseIncl: 13.2, purchaseCurrency: 'USD', purchaseTax: 2.2, sellPrice: 16.5, sellPriceIncl: 19.0, salesTax: 2.5, markupPct: 50.00 },
    { productId: '1008', size: '14', colour: 'Red', productCode: 'P-1008', productName: 'Sample Product H', cost: 3.8, purchaseExcl: 4.3, purchaseIncl: 5.2, purchaseCurrency: 'USD', purchaseTax: 0.9, sellPrice: 8.0, sellPriceIncl: 9.2, salesTax: 1.2, markupPct: 86.05 },
    { productId: '1009', size: '16', colour: 'Yellow', productCode: 'P-1009', productName: 'Sample Product I', cost: 11.2, purchaseExcl: 12.0, purchaseIncl: 14.4, purchaseCurrency: 'USD', purchaseTax: 2.4, sellPrice: 18.0, sellPriceIncl: 20.7, salesTax: 2.7, markupPct: 50.00 },
    { productId: '1010', size: '12', colour: 'Blue', productCode: 'P-1010', productName: 'Sample Product J', cost: 2.9, purchaseExcl: 3.3, purchaseIncl: 3.9, purchaseCurrency: 'USD', purchaseTax: 0.6, sellPrice: 6.5, sellPriceIncl: 7.4, salesTax: 0.9, markupPct: 97.87 },
  ], []);

  return (
    <div className="prices-tab">
      <fieldset className="border rounded m-1 p-2 w-100">
        <Row className='justify-content-end'>
          <Col className='d-flex justify-content-end'>
            <ButtonGroup>
              <UncontrolledDropdown>
                <DropdownToggle tag="button" className="btn btn-light btn-sm">
                  Select price list <i className="mdi mdi-chevron-down"></i>
                </DropdownToggle>
                <DropdownMenu>
                  <DropdownItem>Action</DropdownItem>
                  <DropdownItem>Another action</DropdownItem>
                  <DropdownItem>Something else here</DropdownItem>
                  <DropdownItem divider />
                  <DropdownItem>Separated link</DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
            </ButtonGroup>
          </Col>
        </Row>
        <Row className="mt-1 mb-2">
          <div className='table-responsive w-100'>
            <TableContainerReactTable
              columns={columns}
              data={data}
              isGlobalFilter={false}
              customPageSize={5}
              divClass="mb-0"
              tableClass="table-centered align-middle table-nowrap mb-0"
              theadClass="table-light"
              thClass="px-3 py-2"
              verticalLines={true}
            />
          </div>
        </Row>
        <Row>
          <Col className="d-flex justify-content-start">
            <button className="btn btn-soft-primary btn-sm" style={{ minWidth: 120 }}>
              Reapply Prices
            </button>
          </Col>
        </Row>
      </fieldset>
    </div>
  );
};

export default PricesTab;
